import React, { useState, type FC } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, Box, Text, xcss } from '@atlaskit/primitives';
import Image from '@atlaskit/image';
import { FadeIn } from '@atlaskit/motion';

const containerStyles = xcss({
	width: '100%',
	flexGrow: 1,
	paddingBottom: 'space.300',
});

const imageStyles = xcss({
	width: '96px',
	height: '96px',
});

export const AccessRequestsTableState: FC<{
	textLine: React.ReactNode;
	secondTextLine?: React.ReactNode;
	srcLight: string;
	srcDark: string;
}> = ({ textLine, secondTextLine, srcLight, srcDark }) => {
	const [imageLoading, setImageLoading] = useState(true);
	const [imageAnimationFinished, setImageAnimationFinished] = useState(false);
	const shouldPauseAnimation = imageLoading || imageAnimationFinished;

	return (
		<Stack alignInline="center" alignBlock="center" xcss={containerStyles}>
			<FadeIn
				duration="large"
				entranceDirection="top"
				isPaused={shouldPauseAnimation}
				onFinish={() => setImageAnimationFinished(true)}
			>
				{({ ...props }) => (
					<div {...props}>
						<Box xcss={imageStyles}>
							<Image
								src={srcLight}
								srcDark={srcDark}
								alt=""
								onLoad={() => setImageLoading(false)}
							/>
						</Box>
					</div>
				)}
			</FadeIn>
			<FadeIn duration="large">
				{({ ...props }) => (
					<div {...props}>
						<Stack alignInline="center" alignBlock="center">
							<Text color="color.text.subtlest" size="medium" align="center">
								{textLine}
							</Text>
							{secondTextLine && (
								<Text color="color.text.subtlest" size="medium" align="center">
									{secondTextLine}
								</Text>
							)}
						</Stack>
					</div>
				)}
			</FadeIn>
		</Stack>
	);
};
